import React from "react";
import classes from "./Ribbon.module.css"
const Ribbon = () => {

    return (<div className={classes.box}>
        <div className={`${classes.ribbon} ${classes.ribbonBottomRight}`}><span data-content="Beta"></span></div>
    </div>
    )
}

export default Ribbon